import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'

import '@/assets/js/constants'
import '@/assets/js/host_frontend'
import '@/assets/js/api_system'
import {
  piGetAccessToken,
  piGetUid,
  getPiUserPoint,
} from '@/utility/pi_controller.js'
import { getTokenInfo } from '@/utility/token_handler.js'
import '@/assets/js/api'

import VueLazyload from 'vue-lazyload'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueClipboard from 'vue-clipboard2'
import 'swiper/dist/css/swiper.css'
import gallery from 'img-vuer'
import moment from 'moment'
import _ from 'lodash'

Vue.prototype.$bus = new Vue()
Vue.prototype.$moment = moment
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
Vue.use(VueAwesomeSwiper /* { default global options } */)
Vue.use(VueAxios, axios)
Vue.component(VueQrcode.name, VueQrcode)
Vue.use(gallery, {
  swipeThreshold: 150,
  isIndexShow: false, // show image index, default true
  useCloseButton: true, // trigger gallery close with close button, default true
  preload: true, // preload images in the same group, default true
})
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
})
Vue.config.devtools = process.env.VUE_APP_USE_DEVTOOL == 'true'
Vue.config.productionTip = false
Vue.config.useDemo = process.env.VUE_APP_USE_TESTLOGIN == 'true'
localStorage.setItem('APP_INIT', 1)
localStorage.setItem('PREVIEW_MODE', 0)
localStorage.removeItem('PI_USER_INFO')
localStorage.removeItem('PI_POINTS')
localStorage.removeItem('login_err_log')

const globalAllert = new Event('callAllert')
/**
 * @param {String} uid - UID
 * @param {Object} to - 原進入頁面
 * @return {Boolean} 是否正常init及token
 */
async function getE7token(uid, to) {
  const appVer = '1.0.1'
  const os = 'iOS'
  const res = await getTokenInfo(uid, appVer, os, async (Data, checkSum) => {
    try {
      const res = await apiSys.getTokenInfo(Data, checkSum)
      return res
    } catch (error) {
      throw error
    }
  })
  return res
}

/**
 * 取得商城付款方式
 */
async function getInitialConfig() {
  localStorage.setItem('collectionList', JSON.stringify([]))
  try {
    const res = await api.getInitialConfig()
    window.localStorage.setItem(
      'initial_config',
      JSON.stringify(_.omit(res.data, ['buyer', 'einvoice']))
    )
    return true
  } catch (error) {
    console.log('getInitialConfig fail', err)
    return false
  }
  // if (process.env.VUE_APP_USE_DEV == 'true') {
  //   try {
  //     const res = await api.getCollectionList()
  //     localStorage.setItem('collectionList', JSON.stringify(res.data))
  //   } catch (error) {
  //     if (error && error.code === 1140) {
  //       console.log('無收藏')
  //     }
  //   }
  // }
}

/**
 * 取得PI使用者資料及點數
 * @param {String} UID - UID
 * @param {String} grantCode - PI GRANT CODE
 * @param {String} havePitoken init時是否有pitoken
 */
async function getPiUserInfo(UID = '', grantCode = '', havePitoken = '') {
  if (UID === 'test') return
  try {
    await getPiUserPoint()
  } catch (error) {
    if (grantCode && havePitoken == 'active') {
      try {
        await piGetAccessToken(grantCode)
        getPiUserInfo()
      } catch (error) {
        globalAllert.messageContent = '取得使用者資料失敗'
        globalAllert.callback = () => {
          localStorage.removeItem('PI_TOKEN')
          localStorage.removeItem('PI_UID')
          location.reload()
        }
        window.dispatchEvent(globalAllert)
      }
    } else {
      globalAllert.messageContent = '取得使用者資料失敗'
      globalAllert.callback = () => {
        localStorage.removeItem('PI_TOKEN')
        localStorage.removeItem('PI_UID')
        location.reload()
      }
      window.dispatchEvent(globalAllert)
    }
  }
}

/**
 * 阻止返回上一頁
 */
function handleBack() {
  if (typeof history.pushState === 'function') {
    console.log('handleBack')
    history.pushState('jibberish', null, null)
    history.pushState('jibberish', null, null)
    history.pushState('jibberish', null, null)
    window.onpopstate = function() {
      history.pushState('newjibberish', null, null)
      // Handle the back (or forward) buttons here
      // Will NOT handle refresh, use onbeforeunload for this.
    }
  }
}
/**
 * 移除登入動畫
 */
function loginDone() {
  localStorage.setItem('APP_INIT', 0)
  if (document.getElementById('init_loading')) {
    document.getElementById('init_loading').remove()
    // document.getElementById('init_loading').classList.add('fade-out')
    // setTimeout(() => {
    //   document.getElementById('init_loading').remove()
    // }, 300)
  }
}

/**
 * 轉導至pi oAuth
 * @param {Object} to - 原進入頁面
 */
function toPiOauth(to) {
  window.location =
    process.env.VUE_APP_PI_OAUTHURL +
    process.env.VUE_APP_PI_3RDPARTNAME +
    '?' +
    `state=login&refer=${encodeURIComponent(to.fullPath)}`
}

/**
 * 確定是否已有有效PI_TOKEN
 * @return {String} null,active,expire
 */
function checkPiToken() {
  const piToken = JSON.parse(localStorage.getItem('PI_TOKEN'))
  if (!piToken) return 'null'
  if (Date.now() < piToken.active_time) {
    return 'active'
  } else if (Date.now() < piToken.active_time + 1296000000) {
    return 'expire'
  } else {
    return 'null'
  }
}

router.beforeEach(async (to, from, next) => {
  if (to.name == 'paymentResult') {
    handleBack()
  }
  if (localStorage.getItem('APP_INIT') == 1) {
    if (to.name !== 'paymentResult') localStorage.removeItem('source')

    if (to.query.preview) {
      // 後台預覽
      localStorage.setItem('PREVIEW_MODE', 1)
      localStorage.setItem('tokenInfo', to.query.pt)
      loginDone()
      next()
    } else if (to.query.code) {
      // 經由pi登入後
      localStorage.setItem('PI_GRANT_CODE', to.query.code)
      localStorage.setItem('PI_REDIRECT', to.query.refer || '')
      if (to.query.refer) {
        next({
          path: to.query.refer,
          query: { piInit: true },
          replace: true,
        })
      } else {
        next({
          path: '/',
          query: { piInit: true },
          replace: true,
        })
      }
    } else {
      const havePitoken = checkPiToken() // 'null' 'expire' 'active'
      const havePiUid = localStorage.getItem('PI_UID') ? true : false
      let grantCode = ''
      let uid = ''
      if (to.query.piInit) grantCode = localStorage.getItem('PI_GRANT_CODE')
      if (havePitoken != 'active') {
        // Access Token 沒有或過期
        if (grantCode) {
          try {
            await piGetAccessToken(grantCode)
            if (!havePiUid) uid = await piGetUid()
            else uid = localStorage.getItem('PI_UID')
          } catch (error) {
            globalAllert.messageContent = '登入失敗！'
            globalAllert.callback = () => {
              location.reload()
            }
            window.dispatchEvent(globalAllert)
            return error
          }
        } else if (Vue.config.useDemo && confirm('是否使用test帳號登入')) {
          uid = 'test'
          if (!to.query.source) {
            localStorage.setItem('source', 'cafe')
          }
        } else {
          toPiOauth(to)
          return
        }
      } else {
        if (havePiUid) {
          uid = localStorage.getItem('PI_UID')
        } else {
          uid = await piGetUid()
        }
      }
      const result = await getE7token(uid, to)
      if (result && result.code === 1000) {
        localStorage.setItem('tokenInfo', result.data)
        if (to.query.source) {
          localStorage.setItem('source', to.query.source)
        } else if (!to.meta.passTitleCheck) {
          document.title = '拍好康'
        }
        await getInitialConfig()
        loginDone()
        next()
        getPiUserInfo(uid, grantCode, havePitoken)
      } else {
        globalAllert.messageContent =
          '登入失敗' +
          (result
            ? result.code
              ? '(' + result.code + ')'
              : result == '-99999'
              ? '(-99999)'
              : '(-11111)'
            : '(-00000)')
        if (result) {
          localStorage.setItem('login_err_log', JSON.stringify(result))
        }
        globalAllert.callback = () => {
          location.reload()
        }
        window.dispatchEvent(globalAllert)
      }
    }
  } else {
    // if (to.meta.title != null) {
    //   document.title = to.meta.title
    //   if (window['host_title'] != null) {
    //     window['host_title'](document.title)
    //   }
    // }
    next()
  }
})

Vue.filter('formatDateTime', function(value, option) {
  if (value == null || value == '') return ''
  const dateTime = moment(value, 'YYYY/MM/DD HH:mm:ss')
  if (option === 'date') {
    return dateTime.format('YYYY年MM月DD日')
  }
  if (option === 'time') {
    return dateTime.format('HH:mm:ss')
  }
  if (option === 'dateSimple') {
    return dateTime.format('YYYY/MM/DD HH:mm')
  }
  if (option === 'YYYY/MM/DD') {
    return dateTime.format('YYYY/MM/DD')
  }
  return dateTime.format('YYYY年MM月DD日 HH:mm:ss')
})

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
router.afterEach(to => {
  if (typeof gtag == 'function') {
    gtag('config', process.env.VUE_APP_GA_TRACK_ID, {
      page_path: to.fullPath,
    })
  }
})
